import React from 'react';
import { useSignal } from '@funtech-int/rival-react';
import classnames from 'classnames';
import { AnalyticsSenderProvider } from '@funtech-int/yango-shared';

import { useProfileManager } from '@/shared/hooks/useProfileManager';
import { clientOnlyPage } from '@/shared/lib/clientOnly';
import { AutoOpenPaymentWidget } from '@/shared/components/AutoOpenPaymentWidget/AutoOpenPaymentWidget';
import { clientConfig } from '@/config/client';

import { WatchSettings } from '../WatchSettings/WatchSettings';
import { SubscriptionSettings } from '../SubscriptionSettings/SubscriptionSettings';
import { useI18n } from '../../hooks/useI18n';
import { DisplayLanguageSetting } from '../DisplayLanguageSetting/DisplayLanguageSetting';
import { SettingsHead } from '../SettingsHead/SettingsHead';

import styles from './Settings.module.css';

const {
    i18n: { displayLanguages },
} = clientConfig;

const SettingsContent = clientOnlyPage(() => {
    const i18n = useI18n();

    const hasSubscription = useSignal(useProfileManager().hasSubscription);

    return (
        <AnalyticsSenderProvider>
            <main className={styles.root}>
                <h1 className={classnames(styles.title, styles.rootTitle)}>
                    {i18n('page_content__title')}
                </h1>

                <div className={styles.sections}>
                    <section>
                        <h2 className={styles.sectionTitle}>{i18n('watching_section__title')}</h2>
                        <WatchSettings />
                    </section>
                    {displayLanguages && (
                        <section>
                            <h2 className={styles.sectionTitle}>
                                {i18n('general_section__title')}
                            </h2>
                            <div className={styles.displayLanguageSetting}>
                                <DisplayLanguageSetting />
                            </div>
                        </section>
                    )}
                    {hasSubscription && (
                        <section>
                            <h2 className={styles.sectionTitle}>
                                {i18n('subscription_section__title')}
                            </h2>
                            <SubscriptionSettings />
                        </section>
                    )}
                </div>
            </main>
            <AutoOpenPaymentWidget />
        </AnalyticsSenderProvider>
    );
});

export const Settings = () => (
    <>
        <SettingsHead />
        <SettingsContent />
    </>
);

export default Settings;
